import { CommonValue } from "./CommonValue";
import { CounterOrderSection } from "./CounterOrderSection";

class LifestyleAndEnvironment extends CounterOrderSection {
    public Remarks: string;
    public RadiationXRays: CommonValue;
    public Trauma: CommonValue;
    public ContactCat: CommonValue;
    public Feeding: CommonValue;
    public Medication: CommonValue;
    public Vaccination: CommonValue;
    public Drugs: CommonValue;
    public Alcohol: CommonValue;
    public Cigarettes: CommonValue;
    public Coffee: CommonValue;
    public FolicAcidSupplement: CommonValue;
    public Sociocultural: CommonValue;
    public Ethnocultural: CommonValue;
    public RiskOfInfection: CommonValue;
    public Occupation: CommonValue;

    constructor(fields?: Partial<LifestyleAndEnvironment>) {
        super();
        Object.assign(this, fields);
        this.RadiationXRays = new CommonValue(fields?.RadiationXRays);
        this.Trauma = new CommonValue(fields?.Trauma);
        this.ContactCat = new CommonValue(fields?.ContactCat);
        this.Feeding = new CommonValue(fields?.Feeding);
        this.Medication = new CommonValue(fields?.Medication);
        this.Vaccination = new CommonValue(fields?.Vaccination);
        this.Drugs = new CommonValue(fields?.Drugs);
        this.Alcohol = new CommonValue(fields?.Alcohol);
        this.Cigarettes = new CommonValue(fields?.Cigarettes);
        this.Coffee = new CommonValue(fields?.Coffee);
        this.FolicAcidSupplement = new CommonValue(fields?.FolicAcidSupplement);
        this.Sociocultural = new CommonValue(fields?.Sociocultural);
        this.Ethnocultural = new CommonValue(fields?.Ethnocultural);
        this.RiskOfInfection = new CommonValue(fields?.RiskOfInfection);
        this.Occupation = new CommonValue(fields?.Occupation);
    }
}

export { LifestyleAndEnvironment };
